<template>
  <div class="video-editing-container">
    <div class="header-section">
      <h1>{{ videoEditing.title }}</h1>
      <p class="subtitle">{{ videoEditing.subtitle }}</p>
    </div>
    
    <div class="projects-grid">
      <div class="column">
        <div v-for="project in oddProjects" :key="project.id" class="project-card">
          <div class="video-preview" @click="playVideo(project)">
            <img v-if="!project.isPlaying" :src="project.thumbnail" :alt="project.alt">
            <iframe v-else
                    :src="getYouTubeEmbedUrl(project.youtubeId)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="video-player">
            </iframe>
            <div v-if="!project.isPlaying" class="play-button">
              <i class="fas fa-play"></i>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <a v-if="project.scenarioLink" :href="project.scenarioLink" target="_blank" class="scenario-link">
              <i class="fas fa-file-pdf"></i> {{ project.scenarioLabel || 'シナリオ' }}
            </a>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Duration:</span>
                <span class="value">{{ project.duration }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Resolution:</span>
                <span class="value">{{ project.resolution }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div v-for="project in evenProjects" :key="project.id" class="project-card">
          <div class="video-preview" @click="playVideo(project)">
            <img v-if="!project.isPlaying" :src="project.thumbnail" :alt="project.alt">
            <iframe v-else
                    :src="getYouTubeEmbedUrl(project.youtubeId)"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="video-player">
            </iframe>
            <div v-if="!project.isPlaying" class="play-button">
              <i class="fas fa-play"></i>
            </div>
          </div>
          <div class="project-info">
            <h3>{{ project.title }}</h3>
            <p>{{ project.description }}</p>
            <a v-if="project.scenarioLink" :href="project.scenarioLink" target="_blank" class="scenario-link">
              <i class="fas fa-file-pdf"></i> {{ project.scenarioLabel || 'シナリオ' }}
            </a>
            <div class="tech-stack">
              <span v-for="tech in project.techStack" :key="tech">{{ tech }}</span>
            </div>
            <div class="project-details">
              <div class="detail-item">
                <span class="label">Duration:</span>
                <span class="value">{{ project.duration }}</span>
              </div>
              <div class="detail-item">
                <span class="label">Resolution:</span>
                <span class="value">{{ project.resolution }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <HomeButton />
</template>

<script>
import resumeData from '@/data/resumeData.js'
import HomeButton from '@/components/common/HomeButton.vue'

export default {
  name: 'VideoEditing',
  components: {
    HomeButton
  },
  data() {
    return {
      videoEditing: {
        ...resumeData.videoEditing,
        projects: resumeData.videoEditing.projects.map(project => ({
          ...project,
          isPlaying: false
        }))
      }
    }
  },
  computed: {
    sortedProjects() {
      return [...this.videoEditing.projects].sort((a, b) => a.id - b.id);
    },
    oddProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 1);
    },
    evenProjects() {
      return this.sortedProjects.filter(project => project.id % 2 === 0);
    }
  },
  methods: {
    playVideo(project) {
      // 停止其他正在播放的视频
      this.videoEditing.projects.forEach(p => {
        if (p !== project) {
          p.isPlaying = false;
        }
      });
      // 播放选中的视频
      project.isPlaying = true;
    },
    getYouTubeEmbedUrl(youtubeId) {
      return `https://www.youtube.com/embed/${youtubeId}?autoplay=1`;
    }
  }
}
</script>

<style scoped>
.video-editing-container {
  padding: 2rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2rem;
}

.header-section h1 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.1rem;
  color: #666;
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 0.5rem;
}

@media (max-width: 992px) {
  .header-section h1 {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    padding: 0;
  }
  
  .video-editing-container {
    padding: 1rem 0.5rem;
  }
  
  .header-section {
    margin-bottom: 1.5rem;
  }
  
  .header-section h1 {
    font-size: 2rem;
  }
}

@media (max-width: 576px) {
  .header-section h1 {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
  
  .project-info h3 {
    font-size: 1.2rem;
  }
  
  .project-info p {
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .tech-stack span {
    font-size: 0.8rem;
    padding: 0.2rem 0.6rem;
  }
  
  .label {
    font-size: 0.8rem;
  }
  
  .value {
    font-size: 0.9rem;
  }
  
  .play-button {
    width: 40px;
    height: 40px;
  }
  
  .play-button i {
    font-size: 1.2rem;
  }
}

.project-card {
  break-inside: avoid;
  margin-bottom: 1.5rem;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 100%;
}

.project-card:hover {
  transform: translateY(-5px);
}

.video-preview {
  position: relative;
  cursor: pointer;
  background: #000;
  aspect-ratio: 16/9;
  overflow: hidden;
}

.video-preview img,
.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-player {
  position: relative;
  z-index: 2;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1;
}

.play-button:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: translate(-50%, -50%) scale(1.1);
}

.play-button i {
  color: white;
  font-size: 1.5rem;
}

.project-info {
  padding: 1.5rem;
}

.project-info h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.project-info p {
  color: #666;
  margin-bottom: 1rem;
}

.tech-stack {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.tech-stack span {
  background: #f0f0f0;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  color: #555;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.9rem;
  color: #666;
}

.value {
  font-weight: 500;
  color: #333;
}

.scenario-link {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #666;
  font-size: 0.9rem;
  text-decoration: none;
  margin-bottom: 1rem;
}

.scenario-link:hover {
  color: #333;
  text-decoration: underline;
}

.scenario-link i {
  color: #e74c3c;
}

/* 触摸设备优化 */
@media (hover: none) {
  .play-button {
    background: rgba(0, 0, 0, 0.5);
  }
  
  .project-card:active {
    transform: translateY(-5px);
  }
}
</style> 